<template>
  <v-row
    no-gutters
    class="home-prontuario-root"
  >
    <info-paciente   
      :id-ordem-servico="mFicha.idOrdemServico"
      :expanded="true"
      :user="user"
      :ficha="mFicha"
      :item="items[selectedItem]"
      class="mb-1"
      @help-requested="handleHelp"
      @logout="handleLogout"
      @paciente-carregado="handlePacienteCarregado"
      @voltar="$emit('addVoltar')"
      @chamada-realizada="manterStatusChamada"
    />
      
    <v-col
      cols="12"
      md="2"
      class="pr-1"
    >
      <!-- Card de Tempo -->
      <v-card
        elevation="2"
        class="mb-2 rounded-ts-xl"
      >
        <v-card-text class="text-center py-4">
          <div
            class="text-h4 tempo-display"
            :class="tempoStatusClass"
          >
            {{ tempoAtd }}
          </div>
        </v-card-text>
      </v-card>

      <!-- Card de Resumo Clínico Separado -->
      <v-card
        :variant="selectedItem == 0 ? 'tonal': 'outlined'"
        class="mb-2 "
        :color="selectedItem == 0 ? items[0].color : 'primary'"
        :class="{ 'nav-disabled': navegacaoBloqueada }"
        @click="selecionarSecao(0)"
      >
        <v-card-item class="py-3">
          <template #prepend>
            <v-icon
              :icon="items[0].icon"
              :color="items[0].color"
              class="mr-3"
            />
          </template>
          <v-card-title class="text-subtitle-1 font-weight-bold  pl-2">
            Resumo Clínico
          </v-card-title>
        </v-card-item>
      </v-card>
           
      <!-- Lista de Itens Alinhada à Esquerda -->
      <v-card
        elevation="2"
        class="mb-2 menu-card"
      >
        <v-list
          density="compact"
          class="py-2 left-aligned-list"
        >
          <v-list-item 
            v-for="(item, i) in menuItems" 
            :key="i" 
            :value="i"
            :disabled="item.disabled || navegacaoBloqueada"
            class="list-item-left"
            :class="{ 'active-item': selectedItem === item.index }"
            @click="selecionarSecao(item.index)"
          >
            <template #prepend>
              <v-icon
                :icon="item.icon"
                :color="item.color"
                class="mr-3"
              />
            </template>
              
            <v-list-item-title class="text-left font-weight-medium">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>

      <!-- Card de Ações -->
      <v-card
        elevation="2"
        class="mb-2 menu-card"
        color="primary"
      >
        <v-card-actions class="pt-4 px-4 pb-4">
          <v-row dense>
            <!-- Botão Finalizar/Voltar -->
            <v-col cols="12">
              <v-btn
                v-if="statusAtual != 4"
                :loading="loadSave"
                block
                outlined
                variant="flat"
                size="small"
                class="mb-1 action-btn"
                @click="mFicha.idProntuario == null ? abrirEncerramento() : $emit('addVoltar')"
              >
                <span
                  :class="['material-icons', mFicha.idProntuario == null ? 'icon-finalizar' : 'icon-voltar']"
                  style="font-size: 18px; margin-right: 4px;"
                >
                  {{ mFicha.idProntuario == null ? 'check_circle' : 'arrow_back' }}
                </span>
                <strong>{{ mFicha.idProntuario == null ? 'Finalizar' : 'Voltar' }}</strong>
              </v-btn>
                
              <v-btn
                v-if="statusAtual == 4"
                block
                color="white"
                variant="flat"
                size="small"
                class="mb-1 action-btn"
                @click="$emit('addVoltar')"
              >
                <span
                  class="material-icons"
                  style="font-size: 18px; margin-right: 4px;"
                >arrow_back</span>
                <strong>Voltar</strong>
              </v-btn>
            </v-col>

            
              
            <!-- Botão Espera -->
            <v-col cols="12">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                location="end"
              >
                <template #activator="{ props }">
                  <v-btn
                    v-if="mFicha.idProntuario == null && statusAtual != 4"
                    :loading="loadingEspera"
                    block
                    color="white"
                    variant="flat"
                    size="small"
                    v-bind="props"
                    class="action-btn"
                  >
                    <span
                      class="material-icons icon-espera"
                      style="font-size: 18px; margin-right: 4px;"
                    >pause</span>
                    <strong>Espera</strong>
                  </v-btn>
                </template>

                <v-card
                  min-width="300"
                  class="card-actions-bottom"
                >
                  <v-card-text class="pt-4">
                    <div class="d-flex align-center mb-3">
                      <span
                        class="material-icons text-warning"
                        style="font-size: 24px; margin-right: 8px;"
                      >warning</span>
                      <p class="text-body-1 mb-0">
                        <strong>Colocar em espera?</strong>
                      </p>
                    </div>
                    <p class="text-caption text-medium-emphasis">
                      O atendimento será pausado e movido para a lista de espera.
                    </p>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      variant="text"
                      size="small"
                      @click="menu = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="warning"
                      variant="tonal"
                      size="small"
                      @click="addListaDeEspera"
                    >
                      <span
                        class="material-icons"
                        style="font-size: 18px; margin-right: 4px;"
                      >check</span>
                      Confirmar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
        
      <!-- Card de Procedimentos -->
      <v-card
        elevation="2"
        class="rounded-bs-xl menu-card"
      >
        <v-card-item>
          <v-card-title class="d-flex align-center text-subtitle-1 font-weight-bold">
            <v-btn
              v-bind="props"
              variant="outlined"
              block
              class="text-none"
              color="primary"
              :disabled="isAtendimentoAtendido"
              @click.stop="abrirDialogNovoLaudo"
            >
              <v-icon left>
                add
              </v-icon>
              Serviços/Exames
            </v-btn>
          </v-card-title>
        </v-card-item>
          
        <v-divider />
          
        <v-list
          density="compact"
          class="procedimentos-list"
        >
          <v-list-item 
            v-for="(item, i) in listaConsultasPaciente" 
            :key="i"
            :disabled="item.cor === 'grey lighten-1'"
            class="px-2 list-item-left"
          >
            <template #prepend>
              <span
                class="material-icons"
                style="font-size: 16px; color: rgb(var(--v-theme-info));"
              >fiber_manual_record</span>
            </template>
            <v-list-item-title class="text-caption text-left">
              {{ item.nomeExame }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>

    <!-- Conteúdo principal -->
    <v-col
      v-if="!dialogEncerramento"
      :cols="sidePanelCollapsed ? 10 : 6"
      class="d-flex flex-column"
    >
      <!-- Resumo Clínico -->
      <v-card
        v-if="selectedItem === 0"
        variant="outlined"
        height="100%"
        :color="items[selectedItem].color"
      >
        <card-toolbar
          :item="items[selectedItem]"
          class="card-toolbar-full"
        >
          <template #actions>
            <v-btn
              icon
              size="small"
              variant="text"
              color="primary"
              @click.stop="toggleSidePanel"
            >
              <v-icon>{{ sidePanelCollapsed ? 'chevron_right' : 'chevron_left' }}</v-icon>
            </v-btn>
          </template>
        </card-toolbar> 
        <v-card 
          flat
          class="h-100 d-flex flex-column"
          style="overflow-y: auto;"
        >
          <v-skeleton-loader
            v-if="loadResumo"
            type="article"
          />
          <v-card-text
            v-else-if="resumoProntuarios"
            style="background-color: white !important; color: rgb(var(--v-theme-on-surface)) !important;"
            class="resumo-display-content"
            v-html="resumoProntuarios"
          />
          <v-card-text
            v-else
            style="background-color: white !important; color: rgb(var(--v-theme-on-surface)) !important;"
            class="resumo-display-content text-grey"
          />
        </v-card>
      </v-card>

      <!-- Prontuário -->
      <div v-if="selectedItem === 1">
        <v-card
          variant="outlined"
          :color="items[selectedItem].color"
          class="flex-grow-1 flex-column"
        >
          <card-toolbar
            :item="items[selectedItem]"
            class="card-toolbar-full"
          >
            <template #actions>
              <v-btn
                icon
                size="small"
                variant="text"
                color="primary"
                @click.stop="toggleSidePanel"
              >
                <v-icon>{{ sidePanelCollapsed ? 'chevron_right' : 'chevron_left' }}</v-icon>
              </v-btn>
            </template>
          </card-toolbar>
          <editor-prontuario
            v-if="!loadProntuario" 
            :key="editorProntuarioKey"
            ref="editorProntuarioRef" 
            :is-ultimo-prontuario="listaPv2.length <= 0" 
            :paciente="mFicha"
            :id-exames-os="idExamesOSProntuario"
            :lista-prontuarios="listaProntuariosMeus"
            :conteudo="conteudoProntuario" 
            :id-prontuario="mFicha.idProntuario" 
            class="flex-grow-1"
            @conteudo="atualizarConteudoProntuario"
            @salvamento-pendente="handleSalvamentoPendente"
          />
        </v-card>
      </div>

      <!-- Receituário -->
      <v-card
        v-if="selectedItem === 3"
        variant="outlined"
        :color="items[selectedItem].color"
        class="d-flex flex-column flex-grow-1 card-actions-bottom"
        max-height="750"
      >
        <card-toolbar
          :item="items[selectedItem]"
          class="card-toolbar-full"
        >
          <template #actions>
            <v-btn
              icon
              size="small"
              variant="text"
              color="primary"
              @click.stop="toggleSidePanel"
            >
              <v-icon>{{ sidePanelCollapsed ? 'chevron_right' : 'chevron_left' }}</v-icon>
            </v-btn>
          </template>
        </card-toolbar>
          
        <v-sheet
          class="flex-grow-1 overflow-y-auto"
          rounded="lg"
        >
          <v-item-group v-if="!isAddReceita">
            <v-container fluid>
              <v-row>
                <v-col
                  v-for="(mReceita, n) in receitas"
                  :key="n"
                  cols="12"
                  sm="6"
                  lg="4"
                >
                  <v-item v-slot="{ }">
                    <v-card
                      variant="outlined"
                      color="grey-lighten-4"
                      height="320"
                      class="card-actions-bottom list-card"
                    >
                      <v-card
                        flat
                        color="grey-lighten-4"
                        class="overflow-auto list-card-content"
                      >
                        <v-card-title 
                          :class="mReceita.descricao.length < 17 ? 'text-h6' : 'text-subtitle-2'"
                          :style="{ 'min-height': !mReceita.obs ? '80px' : 'auto' }"
                        >
                          <div v-html="mReceita.descricao.slice(0, 200) + (mReceita.descricao.length > 200 ? '...' : '')" />
                        </v-card-title>
                      </v-card>
                        
                      <v-divider />
                        
                      <v-card-actions
                        v-if="!mReceita.remove"
                        class="list-card-actions"
                      >                          
                        <!-- Visualizar Receita -->
                        <print-preview 
                          :tipo-impressao="'receita'" 
                          :user="user" 
                          :m-ficha="mFicha"
                          :data-cadastro="getReceitaData(mReceita)"
                          :data-habilitada="mReceita.dataHabilitada !== false"
                          :receita="mReceita"
                          :descricao="mReceita.descricao"
                          :modo="'visualizacao'"
                          :idapicfm-especializacao="selectedRQE"
                        />
                          
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-btn 
                              v-bind="props"
                              icon 
                              color="orange-darken-1" 
                              class="mr-1"
                              @click="editarReceita(n)"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >edit</span>
                            </v-btn>
                          </template>
                          <span>Editar receita</span>
                        </v-tooltip>
                          
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-btn 
                              v-bind="props"
                              icon 
                              color="red-lighten-2" 
                              @click="mReceita.remove = true"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >delete</span>
                            </v-btn>
                          </template>
                          <span>Excluir receita</span>
                        </v-tooltip>
                      </v-card-actions>
                        
                      <template v-else>
                        <v-card-actions class="px-4 pt-2 list-card-actions">
                          <v-spacer />
                          <v-btn
                            icon
                            color="error"
                            variant="tonal"
                            class="mr-1"
                            @click="excluirReceitaMedica(mReceita)"
                          >
                            <span
                              class="material-icons"
                              style="font-size: 18px;"
                            >delete_forever</span>
                          </v-btn>
                          <v-btn
                            icon
                            color="grey-darken-1"
                            variant="text"
                            @click="mReceita.remove = false"
                          >
                            <span
                              class="material-icons"
                              style="font-size: 18px;"
                            >close</span>
                          </v-btn>
                        </v-card-actions>
                      </template>
                    </v-card>
                  </v-item>
                </v-col>
                  
                <v-col
                  cols="12"
                  sm="6"
                  lg="4"
                >
                  <v-item v-slot="{ toggle }">
                    <v-card 
                      color="grey-lighten-4" 
                      class="d-flex align-center justify-center add-card"
                      height="250" 
                      @click="toggle, isAddReceita = true"
                    >
                      <span
                        class="material-icons"
                        :style="{ color: items[mItem].color, fontSize: '32px' }"
                      >medication</span>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
            
          <div>
            <editor-receita 
              v-if="isAddReceita"
              ref="editorReceitaRef" 
              :ficha="mFicha"
              :is-editar-receita="isEditarReceita" 
              :receita-edit="receitaEdit"
              @salvo="handleReceitaSalva"
              @cancelado="cancelarReceita"
            />
          </div>
        </v-sheet>
        <v-card-actions
          v-if="!isAddReceita"
          class="pa-2 actions-footer bottom-actions actions-right"
        >
          <print-preview 
            :tipo-impressao="'receita'" 
            :user="user" 
            :m-ficha="mFicha"
            :items-impressao="receitasImpressao"
            :modo-lote="true"
            :button-text="'Imprimir todos'"
            :button-props="{ color: 'primary', variant: 'outlined', size: 'small' }"
            :idapicfm-especializacao="selectedRQE"
          />
        </v-card-actions>
        <v-card-actions
          v-if="isAddReceita"
          class="pa-2 actions-footer"
        >
          <div class="d-flex align-center rqe-actions">
            <v-switch
              v-model="habilitarRQE"
              label="RQE"
              hide-details
              density="compact"
              color="primary"
            />
            <v-select
              v-if="habilitarRQE"
              v-model="selectedRQE"
              :items="listaRQE"
              item-title="rqe"
              item-value="id"
              label="RQE"
              density="compact"
              variant="outlined"
              hide-details
              class="rqe-select"
              :loading="carregandoLaudo"
            />
          </div>
          <v-spacer />
          <v-btn 
            color="grey-darken-1"
            variant="text" 
            size="small"
            @click="triggerCancelarReceita"
          >
            Voltar
          </v-btn>
          <v-btn 
            color="success"
            variant="outlined"
            size="small"
            class="mr-2"
            @click="triggerSalvarReceitaMais"
          >
            <v-icon
              left
              size="small"
            >
              exposure_plus_1
            </v-icon>
          </v-btn>
          <v-btn 
            color="primary"
            variant="flat"
            size="small"
            @click="triggerSalvarReceita"
          >
            <v-icon
              left
              size="small"
            >
              save
            </v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- Solicitação -->
      <v-card
        v-if="selectedItem === 2"
        variant="outlined"
        :color="items[selectedItem].color"
        class="d-flex flex-column flex-grow-1 card-actions-bottom"
        max-height="750"
      >
        <card-toolbar
          :item="items[selectedItem]"
          class="card-toolbar-full"
        >
          <template #actions>
            <v-btn
              icon
              size="small"
              variant="text"
              color="primary"
              @click.stop="toggleSidePanel"
            >
              <v-icon>{{ sidePanelCollapsed ? 'chevron_right' : 'chevron_left' }}</v-icon>
            </v-btn>
          </template>
        </card-toolbar>
    
        <v-sheet
          class="flex-grow-1"
          style="overflow-y: auto;"
          rounded="lg"
        >
          <v-item-group v-if="!isAddSolicitacao">
            <v-container fluid>
              <v-row>
                <!-- Solicitações Clínicas -->
                <v-col
                  v-for="(solicitacao, n) in solicitacoesCards"
                  :key="`clinica-${n}`"
                  cols="12"
                  sm="6"
                  lg="4"
                >
                  <v-item v-slot="{ }">
                    <v-card
                      flat
                      variant="outlined"
                      height="320"
                      class="card-actions-bottom list-card"
                    >
                      <v-card
                        flat
                        class="overflow-y-auto list-card-content"
                      >
                        <ol class="rounded-list ml-5 mr-1">
                          <!-- Iterar sobre cada item da solicitação -->
                          <li
                            v-for="(item, itemIndex) in solicitacao.items"
                            :key="itemIndex"
                          >
                            <!-- Para cada item, iterar sobre os exames -->
                            <div
                              v-for="exame in item.exames"
                              :key="exame.idExame"
                              class="exame-item"
                            >
                              <a>{{ exame.apelido || exame.nomeExame }}</a>
                            </div>
                          </li>
                        </ol>
                      </v-card>
                  
                      <v-divider />
                      <v-card-actions
                        v-if="!solicitacao.confirmandoExclusao"
                        class="list-card-actions"
                      >
                        <!-- {{ solicitacao }} -->
                        <!-- Imprimir Solicitação -->
                        <print-preview 
                          :tipo-impressao="'solicitacao'" 
                          :user="user" 
                          :m-ficha="mFicha"
                          :solicitacao="solicitacao"
                          :data-cadastro="getSolicitacaoData(solicitacao)"
                          :data-habilitada="solicitacao.dataHabilitada !== false"
                          :medicamentos="solicitacao.items[0].exames"
                          :descricao="solicitacao.observacoes"
                          tipo="solicitacaoReceita"
                          :idapicfm-especializacao="selectedRQE"
                        />
                    
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-btn 
                              v-bind="props"
                              icon 
                              color="primary" 
                              class="mr-1"
                              @click="editSolicitacao(n, false)"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >edit</span>
                            </v-btn>
                          </template>
                          <span>Editar solicitação</span>
                        </v-tooltip>
                    
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-btn 
                              v-bind="props"
                              icon 
                              @click="iniciarExclusaoSolicitacao(solicitacao)"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >delete</span>
                            </v-btn>
                          </template>
                          <span>Excluir solicitação</span>
                        </v-tooltip>
                      </v-card-actions>
                  
                      <template v-else>
                        <v-divider />
                        <v-card-actions class="px-4 pt-2 list-card-actions">
                          <v-spacer />
                          <v-btn
                            icon
                            color="error"
                            variant="tonal"
                            class="mr-1"
                            @click="confirmarExclusaoSolicitacao(n, false)"
                          >
                            <span
                              class="material-icons"
                              style="font-size: 18px;"
                            >delete_forever</span>
                          </v-btn>
                          <v-btn
                            icon
                            color="grey-darken-1"
                            variant="text"
                            @click="cancelarExclusaoSolicitacao(solicitacao)"
                          >
                            <span
                              class="material-icons"
                              style="font-size: 18px;"
                            >close</span>
                          </v-btn>
                        </v-card-actions>
                      </template>
                  
                      <v-divider v-if="solicitacao.observacoes" />
                  
                      <v-textarea 
                        v-if="solicitacao.observacoes"
                        :model-value="solicitacao.observacoes"
                        class="mx-2 mt-2 solicitacao-observacao"
                        bg-color="amber-lighten-5" 
                        color="orange-darken-5"
                        label="Observação" 
                        rows="2"
                        max-rows="2"
                        variant="outlined"
                        density="compact"
                        readonly
                      />
                    </v-card>
                  </v-item>
                </v-col>
            
                <!-- Solicitações de Laboratório -->
                <v-col
                  v-for="(solicitacao, n) in solicitacoesLaboratorioCards"
                  :key="`lab-${n}`"
                  cols="12"
                  sm="6"
                  lg="4"
                >
                  <v-item v-slot="{ }">
                    <v-card
                      flat
                      height="320"
                      class="card-actions-bottom list-card"
                    >
                      <v-card
                        flat
                        class="overflow-y-auto list-card-content"
                      >
                        <ol class="rounded-list ml-5 mr-1">
                          <!-- Iterar sobre cada item da solicitação -->
                          <li
                            v-for="(item, itemIndex) in solicitacao.items"
                            :key="itemIndex"
                          >
                            <!-- Para cada item, iterar sobre os exames -->
                            <div
                              v-for="exame in item.exames"
                              :key="exame.idExame"
                              class="exame-item"
                            >
                              <a>{{ exame.apelido || exame.nomeExame }}</a>
                            </div>
                          </li>
                        </ol>
                      </v-card>
                  
                      <v-divider />
                      <v-card-actions
                        v-if="!solicitacao.confirmandoExclusao"
                        class="list-card-actions"
                      >
                        <v-chip
                          class="ma-2"
                          color="blue"
                          variant="outlined"
                          label
                        >
                          <span
                            class="material-icons mr-1"
                            style="font-size: 16px;"
                          >science</span>
                          Laboratório
                        </v-chip>
                    
                        <v-spacer />
                    
                        <!-- Imprimir Solicitação Laboratório -->
                        <print-preview 
                          :tipo-impressao="'solicitacao-laboratorio'" 
                          :user="user" 
                          :m-ficha="mFicha"
                          :solicitacao="solicitacao"
                          :data-cadastro="getSolicitacaoData(solicitacao)"
                          :data-habilitada="solicitacao.dataHabilitada !== false"
                          :medicamentos="solicitacao.items"
                          :observacao="solicitacao.observacoes"
                          tipo="LABORATORIO"
                          :idapicfm-especializacao="selectedRQE"
                        />
                                        
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-btn 
                              v-bind="props"
                              icon 
                              color="primary" 
                              class="mr-1"
                              @click="editSolicitacao(n, true)"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >edit</span>
                            </v-btn>
                          </template>
                          <span>Editar solicitação</span>
                        </v-tooltip>
                    
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-btn 
                              v-bind="props"
                              icon 
                              @click="iniciarExclusaoSolicitacao(solicitacao)"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >delete</span>
                            </v-btn>
                          </template>
                          <span>Excluir solicitação</span>
                        </v-tooltip>
                      </v-card-actions>
                  
                      <template v-else>
                        <v-card-text class="pt-3 pb-0 list-card-content">
                          <div class="d-flex align-center alert-soft">
                            <span
                              class="material-icons mr-2"
                              style="font-size: 18px;"
                            >warning</span>
                            <div class="text-body-2">
                              Tem certeza que deseja excluir esta solicitação?
                            </div>
                          </div>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions class="px-4 pt-2 list-card-actions">
                          <v-spacer />
                          <v-btn
                            icon
                            color="error"
                            variant="tonal"
                            class="mr-1"
                            @click="confirmarExclusaoSolicitacao(n, true)"
                          >
                            <span
                              class="material-icons"
                              style="font-size: 18px;"
                            >check</span>
                          </v-btn>
                          <v-btn
                            icon
                            color="grey-darken-1"
                            variant="text"
                            @click="cancelarExclusaoSolicitacao(solicitacao)"
                          >
                            <span
                              class="material-icons"
                              style="font-size: 18px;"
                            >close</span>
                          </v-btn>
                        </v-card-actions>
                      </template>
                  
                      <v-divider v-if="solicitacao.observacoes" />
                  
                      <v-textarea 
                        v-if="solicitacao.observacoes"
                        :model-value="solicitacao.observacoes"
                        class="mx-2 mt-2 solicitacao-observacao"
                        bg-color="amber-lighten-5" 
                        color="orange-darken-5"
                        label="Observação" 
                        rows="2"
                        max-rows="2"
                        variant="outlined"
                        density="compact"
                        readonly
                      />
                    </v-card>
                  </v-item>
                </v-col>
            
                <!-- Botão Adicionar -->
                <v-col
                  cols="12"
                  sm="6"
                  lg="4"
                >
                  <v-item v-slot="{ toggle }">
                    <v-card 
                      color="grey-lighten-4" 
                      class="d-flex align-center justify-center add-card"
                      height="250" 
                      @click="toggle, isAddSolicitacao = true"
                    >
                      <span
                        class="material-icons"
                        :style="{ color: items[selectedItem].color, fontSize: '32px' }"
                      >add</span>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
      
          <!-- Componente de Solicitação de Exames -->
          <solicitacao-exames 
            v-if="isAddSolicitacao"
            ref="solicitacaoExamesRef"
            v-model:habilitar-rqe="habilitarRQE" 
            v-model:selected-rqe="selectedRQE"
            :id-consulta="mFicha.idConsulta"
            :dados-edicao="dadosEdicaoSolicitacao"
            :is-edicao="isEditSolicitacao"
            :paciente="mFicha"
            :lista-rqe="listaRQE"
            :loading-rqe="carregandoLaudo"
            @cancelar="resetarFormularioEdicao"
            @salvar-solicitacao="handleSalvarSolicitacao"
            @update-actions-state="onUpdateSolicitacaoActions"
            @update-observacoes="onUpdateSolicitacaoObservacoes"
          />
        </v-sheet>

        <v-card-actions
          v-if="!isAddSolicitacao"
          class="pa-2 actions-footer bottom-actions actions-right"
        >
          <print-preview 
            :tipo-impressao="'solicitacao'" 
            :user="user" 
            :m-ficha="mFicha"
            :items-impressao="solicitacoesImpressao"
            :modo-lote="true"
            :button-text="'Imprimir todos'"
            :button-props="{ color: 'primary', variant: 'outlined', size: 'small' }"
            :idapicfm-especializacao="selectedRQE"
          />
        </v-card-actions>
        
        <v-card-actions
          v-if="isAddSolicitacao"
          class="pa-2 actions-footer"
        >
          <v-btn 
            color="grey-darken-1" 
            variant="text" 
            :disabled="!solicitacaoActionsState.canClear" 
            size="small"
            @click="triggerLimparSolicitacao"
          >
            Limpar
          </v-btn>
          <v-menu location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                color="primary"
                variant="text"
                size="small"
              >
                <v-icon
                  left
                  size="small"
                >
                  folder_special
                </v-icon>
                Modelos
              </v-btn>
            </template>
            <v-list density="compact">
              <v-list-item @click="triggerAbrirPacotesSolicitacao">
                <v-list-item-title>Editar modelos</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="triggerCadastrarPacoteSolicitacao"
              >
                <v-list-item-title>Cadastrar modelo</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-spacer />
          <v-btn 
            color="grey-darken-1"
            variant="text" 
            size="small"
            @click="triggerCancelarSolicitacao"
          >
            Voltar
          </v-btn>
          <v-btn 
            color="success"
            variant="outlined"
            :disabled="!solicitacaoActionsState.canSave"
            size="small"
            class="mr-2"
            @click="triggerSalvarSolicitacaoMais"
          >
            <v-icon
              left
              size="small"
            >
              exposure_plus_1
            </v-icon>
          </v-btn>
          <v-btn 
            color="primary"
            variant="flat"
            :disabled="!solicitacaoActionsState.canSave"
            size="small"
            @click="triggerSalvarSolicitacao"
          >
            <v-icon
              left
              size="small"
            >
              save
            </v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
      
      <!-- Laudo -->
      <v-card
        v-if="selectedItem === 4"
        variant="outlined"
        :color="items[selectedItem].color"
        class="flex-grow-1 flex-column"
        max-height="750"
      >
        <card-toolbar
          :item="items[selectedItem]"
          class="card-toolbar-full"
        >
          <template #actions>
            <v-btn
              icon
              size="small"
              variant="text"
              color="primary"
              @click.stop="toggleSidePanel"
            >
              <v-icon>{{ sidePanelCollapsed ? 'chevron_right' : 'chevron_left' }}</v-icon>
            </v-btn>
          </template>
        </card-toolbar>
        <v-sheet
          class="flex-grow-1 overflow-y-auto"
          rounded="lg"
        >
          <v-item-group v-if="!isAddLaudo">
            <v-container fluid>
              <v-row>
                <v-col 
                  v-for="(consulta, n) in consultasComLaudos" 
                  v-show="deveMostrarLaudo(consulta)" 
                  :key="n" 
                  cols="12"
                  sm="4"
                  lg="6"
                >
                  <v-item>
                    <v-card
                      variant="outlined"
                      height="320"
                      class="card-actions-bottom"
                    >
                      <v-card
                        flat
                        height="60"
                      >
                        <ol class="rounded-exame ml-5 mr-1">
                          <li>
                            <a>{{ consulta.nomeExame }}</a>
                          </li>
                        </ol>
                      </v-card>
                        
                      <v-card
                        flat
                        height="200"
                        class="overflow-y-auto"
                      >
                        <div
                          class="mx-2"
                          v-html="consulta.laudoCarregado"
                        />
                      </v-card>
                        
                      <v-card-actions>
                        <v-chip 
                          class="ma-2"
                          :color="getCorChipLaudo(consulta)"
                          variant="outlined"
                          label 
                          @click="abrirEditorLaudo(consulta)"
                        >
                          <span
                            class="material-icons mr-1"
                            style="font-size: 16px;"
                          >{{ getIconLaudo(consulta) }}</span>
                          {{ getTextoLaudo(consulta) }}
                        </v-chip>
                          
                        <v-chip 
                          v-show="consulta.statusLaudo"
                          :color="getCorStatusLaudo(consulta.statusLaudo)" 
                          label
                        >
                          {{ getTextoStatusLaudo(consulta.statusLaudo) }}
                        </v-chip>
                          
                        <v-spacer />
                          
                        <v-tooltip location="top">
                          <template #activator="{ props: tooltipProps }">
                            <v-btn
                              v-bind="tooltipProps"
                              icon
                              size="small"
                              :loading="carregandoLaudo"
                              :disabled="carregandoLaudo || !temLaudoCadastrado(consulta)"
                              @click="baixarLaudo(consulta.idexamesos)"
                            >
                              <v-icon>visibility</v-icon>
                            </v-btn>
                          </template>
                          <span>Visualizar laudo</span>
                        </v-tooltip>
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              size="small"
                              disabled
                            >
                              <v-icon>qr_code_2</v-icon>
                            </v-btn>
                          </template>
                          <span>QRCode (em breve)</span>
                        </v-tooltip>
                      </v-card-actions>
                    </v-card>
                  </v-item>
                </v-col>
                  
                <!-- Mensagem quando não há laudos -->
                <v-col
                  v-if="listaConsultasPaciente.length === 0"
                  cols="12"
                >
                  <v-alert
                    type="info"
                    class="ma-4"
                  >
                    Nenhuma consulta encontrada para este atendimento.
                  </v-alert>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  lg="6"
                >
                  <v-card
                    color="grey-lighten-4"
                    class="d-flex flex-column add-card"
                    :class="{ 'add-card--disabled': isAtendimentoAtendido }"
                    height="320"
                    @click="handleAddCardClick"
                  >
                    <div
                      class="d-flex align-center justify-center fill-height"
                    >
                      <v-btn
                        icon
                        size="large"
                        variant="text"
                        @click.stop="handleAddCardClick"
                      >
                        <v-icon size="36">
                          add
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
            
          <div v-if="consultaAux">
            <div v-if="consultaAux.exigeFichaAso">
              <ficha-paciente 
                v-if="isAddLaudo && !consultaAux.psicoSocial"
                :id-exames-os="consultaAux.idexamesos" 
                @voltar="voltarLaudo()" 
              />
              <anamnese-exame2 
                v-if="isAddLaudo && consultaAux.psicoSocial"
                :id-exames-os="consultaAux.idexamesos" 
                @voltar="voltarLaudo()" 
              />
            </div>
              
            <v-card
              v-else
              flat
              class="pa-2 card-actions-bottom"
            >
              <editor-laudo
                ref="editorLaudoRef"
                :paciente="mFicha"
                :consulta="consultaAux"
                :user-aux="user"
                @voltar="fecharEditor"
              />
              <v-card-actions
                v-if="isAddLaudo"
                class="pa-2 actions-footer"
              >
                <div class="d-flex align-center rqe-actions">
                  <v-checkbox
                    v-model="habilitarRQE"
                    label="RQE"
                    hide-details
                    density="compact"
                    color="primary"
                  />
                  <v-select
                    v-if="habilitarRQE"
                    v-model="selectedRQE"
                    :items="listaRQE"
                    item-title="rqe"
                    item-value="id"
                    label="RQE"
                    density="compact"
                    variant="outlined"
                    hide-details
                    class="rqe-select"
                    :loading="carregandoLaudo"
                  />
                </div>
                <v-spacer />
                <v-btn 
                  color="grey-darken-1"
                  variant="text" 
                  size="small"
                  @click="triggerCancelarLaudo"
                >
                  Voltar
                </v-btn>
                <v-btn 
                  color="primary"
                  variant="flat"
                  size="small"
                  @click="triggerSalvarLaudo"
                >
                  <v-icon
                    left
                    size="small"
                  >
                    save
                  </v-icon>
                  Salvar
                </v-btn>
              </v-card-actions>
              <ficha-paciente 
                v-show="false"
                :id-exames-os="consultaAux.idexamesos" 
                @voltar="voltarLaudo()" 
              />
            </v-card>
          </div>
        </v-sheet>
      </v-card>

      <!-- Relatório -->
      <v-card
        v-if="selectedItem === 5"
        variant="outlined"
        :color="items[selectedItem].color"
        class="d-flex flex-column flex-grow-1 card-actions-bottom"
        max-height="750"
      >
        <card-toolbar
          :item="items[selectedItem]"
          class="card-toolbar-full"
        >
          <template #actions>
            <v-btn
              icon
              size="small"
              variant="text"
              color="primary"
              @click.stop="toggleSidePanel"
            >
              <v-icon>{{ sidePanelCollapsed ? 'chevron_right' : 'chevron_left' }}</v-icon>
            </v-btn>
          </template>
        </card-toolbar>
        <v-sheet
          class="flex-grow-1 overflow-y-auto"
          rounded="lg"
        >
          <div v-if="!isAddRelatorio">            
            <v-item-group>
              <v-container fluid>
                <v-row>
                  <v-col
                    v-for="(mRelatorio, n) in relatorios"
                    :key="n"
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-item v-slot="{ }">
                      <v-card
                        variant="outlined"
                        color="grey-lighten-4"
                        height="320"
                        class="card-actions-bottom list-card"
                      >
                        <v-card
                          flat
                          color="grey-lighten-4"
                          class="overflow-auto list-card-content"
                        >
                          <v-card-title 
                            :class="mRelatorio.descricao.length < 17 ? 'text-h6' : 'text-subtitle-2'"
                            :style="{ 'min-height': !mRelatorio.descricao ? '80px' : 'auto' }"
                          >
                            <div v-html="mRelatorio.descricao.slice(0, 200) + (mRelatorio.descricao.length > 200 ? '...' : '')" />
                          </v-card-title>
                        </v-card>
                          
                        <v-divider />
                          
                        <v-card-actions
                          v-if="!mRelatorio.confirmandoExclusao"
                          class="list-card-actions"
                        >
                          <!-- Visualizar Relatório -->
                          <print-preview 
                            :tipo-impressao="'relatorio'" 
                            :user="user" 
                            :m-ficha="mFicha"
                            :data-cadastro="getRelatorioData(mRelatorio)"
                            :relatorio="mRelatorio"
                            :modo="'visualizacao'"
                            :idapicfm-especializacao="selectedRQE"
                          />
                            
                          <v-tooltip location="top">
                            <template #activator="{ props }">
                              <v-btn 
                                v-bind="props"
                                icon 
                                color="orange" 
                                class="mr-1"
                                @click="relatorio = mRelatorio, isAddRelatorio = true"
                              >
                                <span
                                  class="material-icons"
                                  style="font-size: 18px;"
                                >edit</span>
                              </v-btn>
                            </template>
                            <span>Editar relatório</span>
                          </v-tooltip>
                            
                          <v-tooltip location="top">
                            <template #activator="{ props }">
                              <v-btn 
                                v-bind="props"
                                icon 
                                color="red"
                                @click="iniciarExclusao(mRelatorio)"
                              >
                                <span
                                  class="material-icons"
                                  style="font-size: 18px;"
                                >delete</span>
                              </v-btn>
                            </template>
                            <span>Excluir relatório</span>
                          </v-tooltip>
                        </v-card-actions>
                          
                        <template v-else>
                          <v-card-actions class="px-4 pt-2 list-card-actions">
                            <v-spacer />
                            <v-btn
                              icon
                              color="error"
                              variant="tonal"
                              class="mr-1"
                              @click="confirmarExclusao(mRelatorio)"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >delete_forever</span>
                            </v-btn>
                            <v-btn
                              icon
                              color="grey-darken-1"
                              variant="text"
                              @click="cancelarExclusao(mRelatorio)"
                            >
                              <span
                                class="material-icons"
                                style="font-size: 18px;"
                              >close</span>
                            </v-btn>
                          </v-card-actions>
                        </template>
                      </v-card>
                    </v-item>
                  </v-col>
                    
                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                  >
                    <v-item v-slot="{ toggle }">
                      <v-card 
                        color="grey-lighten-4" 
                        class="d-flex align-center justify-center add-card"
                        height="150" 
                        @click="relatorio = null, toggle, isAddRelatorio = true"
                      >
                        <span
                          class="material-icons"
                          :style="{ color: items[mItem].color, fontSize: '32px' }"
                        >add</span>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </div>
            
          <editor-relatorio 
            v-else 
            ref="editorRelatorioRef"
            :relatorio="relatorio" 
            :paciente="mFicha" 
            @voltar="voltarRelatorio()" 
          /> 
        </v-sheet>
        <v-card-actions
          v-if="!isAddRelatorio"
          class="pa-2 actions-footer bottom-actions actions-right"
        >
          <print-preview 
            :tipo-impressao="'relatorio'" 
            :user="user" 
            :m-ficha="mFicha"
            :items-impressao="relatoriosImpressao"
            :modo-lote="true"
            :button-text="'Imprimir todos'"
            :button-props="{ color: 'primary', variant: 'outlined', size: 'small' }"
            :idapicfm-especializacao="selectedRQE"
          />
        </v-card-actions>
        <v-card-actions
          v-if="isAddRelatorio"
          class="pa-2 actions-footer"
        >
          <div class="d-flex align-center rqe-actions">
            <v-switch
              v-model="habilitarRQE"
              label="RQE"
              hide-details
              density="compact"
              color="primary"
            />
            <v-select
              v-if="habilitarRQE"
              v-model="selectedRQE"
              :items="listaRQE"
              item-title="rqe"
              item-value="id"
              label="RQE"
              density="compact"
              variant="outlined"
              hide-details
              class="rqe-select"
              :loading="carregandoLaudo"
            />
          </div>
          <v-spacer />
          <v-btn 
            color="grey-darken-1"
            variant="text" 
            size="small"
            @click="triggerCancelarRelatorio"
          >
            Voltar
          </v-btn>
          <v-btn 
            color="success"
            variant="outlined"
            size="small"
            class="mr-2"
            @click="triggerSalvarRelatorioMais"
          >
            <v-icon
              left
              size="small"
            >
              exposure_plus_1
            </v-icon>
          </v-btn>
          <v-btn 
            color="primary"
            variant="flat"
            size="small"
            @click="triggerSalvarRelatorio"
          >
            <v-icon
              left
              size="small"
            >
              save
            </v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col
      v-else
      cols="12"
      :md="sidePanelCollapsed ? 10 : 6"
    >
      <encerrar-atendimento
        v-model="dialogEncerramento"
        :m-ficha="mFicha"
        :consultas-paciente="listaConsultasPaciente"
        :user="user"
        :tempo-atd="tempoAtd"
        :conteudo-prontuario="conteudoProntuario"
        @atendimento-encerrado="onAtendimentoEncerrado"
        @fechar="onFecharEncerramento"
      />
    </v-col>
    <v-col
      cols="12"
      md="4"
      :class="['side-panel-col', { 'side-panel-col--collapsed': sidePanelCollapsed }]"
    >
      <div class="side-panel-content">
        <transition name="fade">
          <div
            v-if="!sidePanelCollapsed"
            class="ai-side-panel ml-1"
          >
            <meus-atendimentos
              :user="user"
              :id-paciente="mFicha.idPaciente"
              @lista-prontuarios="onListaProntuarios"
            />
          </div>
        </transition>
      </div>
    </v-col>
  </v-row>
  <!-- Diálogos e modais -->
  <v-dialog
    v-model="dialogNovoLaudo"
    max-width="720"
  >
    <v-card class="card-actions-bottom">
      <v-toolbar
        color="primary"
        density="compact"
      >
        <v-toolbar-title class="text-white">
          Adicionar novos Serviços/Exames
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="fecharDialogNovoLaudo"
        >
          <span class="material-icons text-white">close</span>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-text-field
          v-model="filtroExamesOs"
          density="compact"
          variant="outlined"
          hide-details
          placeholder="Buscar exame..."
        />
        <v-progress-linear
          v-if="loadValoresExamesOs"
          color="primary"
          indeterminate
          class="mt-3"
        />
        <div
          v-else-if="examesFiltradosOs.length === 0"
          class="text-center text-grey-darken-1 mt-4"
        >
          Não encontramos exames disponíveis para adicionar ou seu acesso não está liberado. Por favor, entre em contato com a administração.
        </div>
        <v-list
          v-else
          class="overflow-y-auto mt-2"
          density="compact"
        >
          <template
            v-for="(exame, index) in examesFiltradosOs"
            :key="exame.idexame || exame.idExame || index"
          >
            <v-list-item @click="selecionarExameParaLaudo(exame)">
              <v-list-item-title>{{ exame.exame }}</v-list-item-title>
              <template #append>
                <v-icon v-if="isExameSelecionado(exame)">
                  check_circle
                </v-icon> 
                <v-icon v-else>
                  radio_button_unchecked
                </v-icon>
              </template>
            </v-list-item>
            <v-divider v-if="index < examesFiltradosOs.length - 1" />
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          @click="fecharDialogNovoLaudo"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          size="small"
          :disabled="examesSelecionados.length === 0"
          @click="confirmarExameParaLaudoDialog"
        >
          Próximo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="dialogAlerta"
    max-width="500"
  >
    <v-card class="card-actions-bottom">
      <v-toolbar
        color="error"
        density="compact"
      >
        <span class="material-icons mr-2 text-white">warning</span>
        <v-toolbar-title class="text-white">
          Atenção
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="dialogAlerta = false"
        >
          <span class="material-icons text-white">close</span>
        </v-btn>
      </v-toolbar>
        
      <v-card-text class="pt-4 text-body-1">
        {{ mensagemAlerta }}
      </v-card-text>
        
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="dialogAlerta = false"
        >
          Entendi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="dialogConfirmarLaudo"
    max-width="650"
  >
    <v-card class="card-actions-bottom">
      <v-toolbar
        color="primary"
        density="compact"
      >
        <v-toolbar-title class="text-white">
          Confirmação de Solicitação de Exames e Laudo
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="dialogConfirmarLaudo = false"
        >
          <span class="material-icons text-white">close</span>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <div class="text-body-1 mb-3">
          Ao confirmar, os exames selecionados serão registrados, o laudo será disponibilizado para preenchimento e será gerada uma ordem de serviço para pagamento na recepção.
        </div>
        <div class="text-body-1 mb-3">
          <strong>⚠️ Atenção:</strong> após esta confirmação, somente a recepção poderá cancelar o laudo e a ordem de serviço gerada.
        </div>
        <div class="text-body-1 mb-2">
          Exames selecionados:
        </div>
        <v-list density="compact">
          <v-list-item
            v-for="(exame, idx) in examesSelecionados"
            :key="idx"
          >
            <v-list-item-title>{{ exame.exame }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <div class="text-body-1 mt-3">
          Deseja continuar?
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          @click="dialogConfirmarLaudo = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :loading="salvandoExamesLaudo"
          @click="executarCadastroLaudo"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Visualizador de PDF do laudo -->
  <v-dialog
    v-model="dialogLaudoPdf"
    max-width="90%"
    persistent
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">
          picture_as_pdf
        </v-icon>
        Visualizador de laudo
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="fecharVisualizacaoLaudo"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div
          v-if="!laudoPdfSource"
          class="text-center py-6"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
          <div class="mt-3">
            Carregando PDF...
          </div>
        </div>
        <div v-else>
          <object
            :data="laudoPdfSource"
            type="application/pdf"
            width="100%"
            height="600px"
            style="border: none;"
          >
            <p>
              Seu navegador bloqueou a visualização.
              <a
                :href="laudoPdfUrl || laudoPdfSource"
                target="_blank"
                rel="noopener noreferrer"
              >Clique aqui para abrir em nova guia</a>.
            </p>
          </object>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed, onMounted, watch, onUnmounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import medicoService from '../../../services/medico.service'
import editorProntuario from '../editor/editorProntuario.vue'
import editorRelatorio from '../editor/editorRelatorio.vue'
import editorLaudo from '../editor/editorLaudo.vue'
import receita from './receita.vue'
import solicitacaoExames from './solicitacaoExames.vue'
import infoPaciente from './infoPaciente.vue'
import meusAtendimentos from './meusAtendimentos.vue'
import cardToolbar from './cardToolbar.vue'
import printPreview from './printPreview.vue'
import encerrarAtendimento from './encerrarAtendimento.vue'
import fichaPaciente from './fichaPaciente.vue'
import anamneseExame2 from '../anamneseExame2.vue'
import EventBus from '@/EventBus'

export default {
  name: 'AtendimentoMedico',
  
  components: {
    'editor-prontuario': editorProntuario,
    'editor-relatorio': editorRelatorio,
    'solicitacao-exames': solicitacaoExames,
    'editor-receita': receita,
    'info-paciente': infoPaciente,
    'meus-atendimentos': meusAtendimentos,
    'card-toolbar': cardToolbar,
    'print-preview': printPreview,
    'encerrar-atendimento': encerrarAtendimento,
    'editor-laudo': editorLaudo,
    'ficha-paciente': fichaPaciente,
    'anamnese-exame2': anamneseExame2
  },
  
  props: {
    tempoAtd: {
      type: String,
      default: '00:00:00'
    },
    mFicha: {
      type: Object,
      required: true
    },
    consultasPaciente: {
      type: Array,
      default: () => []
    }
  },
  
  emits: ['addVoltar', 'addListaDeEspera', 'encerrarAtd'],
  
    setup(props, { emit }) {
    const store = useStore()
    const user = computed(() => store.getters.usuario)
    
    // Refs para estado reativo
    const mItem = ref(0)
    const selectedItem = ref(0)
    const dialogAlerta = ref(false)
    const mensagemAlerta = ref('')
    const dialog = ref(false)
    const erroProntuarioVazio = ref(false)
    const dialogLaudo = ref(false)
    const dialogProntuario = ref(false)
    const dialogConfirmarLaudo = ref(false)
    const dialogNovoLaudo = ref(false)
    const desejaEncerrar = ref(false)
    const statusOverride = ref(null)
    const statusAtual = computed(() => statusOverride.value ?? props.mFicha.status)
    const isAtendimentoAtendido = computed(() => statusAtual.value === 4)
    const menu = ref(false)
    const dialogEncerramento = ref(false)
    
    const loadReceita = ref(false)
    const loadProntuario = ref(false)
    const loadResumo = ref(false)
    const loadRelatorio = ref(false)
    const loadListaProntuario = ref(false)
    const listaProntuariosMeus = ref([])
    const loadValoresExamesOs = ref(false)
    const mostrarListaExames = ref(false)
    const bloqueioSalvamento = ref(false)
    const sidePanelCollapsed = ref(false)
    const navegacaoBloqueada = computed(() => dialogEncerramento.value)
    const isAddReceita = ref(false)
    const continuarAdicionando = ref(false)
    const isEditarReceita = ref(false)
    const isAddSolicitacao = ref(false)
    const isEditSolicitacao = ref(false)
    const isAddLaudo = ref(false)
    const isAddRelatorio = ref(false)
    const isLab = ref(false)
    const consultaAux = ref(null)
    const relatorio = ref(null)
    const blockMethod = ref(false)
    const listaConsultasPaciente = ref([])
    const loadingEspera = ref(false)
    const loadSave = ref(false)
    const carregandoLaudo = ref(false)
    const salvandoExamesLaudo = ref(false)

    const dialogLaudoPdf = ref(false)
    const laudoPdfBlob = ref(null)
    const laudoPdfUrl = ref(null)
    const laudoPdfSource = ref(null)

    const listaRQE = ref([])
    const selectedRQE = ref(null)
    const currentIdExamesOS = ref(null)
    const usarLogo = ref('1') // Por padrão, usa o logo
    const habilitarRQE = ref(true)
    
    // NOVAS REFS PARA LAUDOS
    const laudosCarregados = ref({})
    
    // REFS PARA PADRONIZAÇÃO DE COMPONENTES
    const solicitacaoExamesRef = ref(null)
    const editorReceitaRef = ref(null)
    const editorProntuarioRef = ref(null)
    const editorLaudoRef = ref(null)
    const editorRelatorioRef = ref(null)
    const solicitacaoActionsState = ref({ canSave: false, canClear: false })
    const dadosEdicaoSolicitacao = ref(null)
    const indexToEdit = ref('')
    const indexToEditLab = ref('')
    

    // Dados reativos
    const items = ref([
      {
        text: "Resumo Clínico",
        icon: "book",
        id: 1,
        badge: 0,
        disabled: false,
        color: "#00BCD4"
      },
      {
        text: "Prontuário",
        icon: "assignment",
        id: 2,
        badge: 0,
        disabled: false,
        color: "#1E88E5"
      },
      {
        text: "Solicitação",
        icon: "article",
        id: 6,
        badge: 0,
        disabled: false,
        color: "#7B68EE"
      },
      {
        text: "Receituário",
        icon: "medication",
        id: 4,
        badge: 0,
        disabled: false,
        color: "#FFA07A"
      },  
      {
        text: "Laudo",
        icon: "content_paste",
        badge: 0,
        id: 7,
        disabled: false,
        color: "#32CD32"
      },
      {
        text: "Relatório",
        icon: "book",
        id: 8,
        badge: 0,
        disabled: false,
        color: "#9370DB"
      }
    ])

    // Menu items sem o resumo clínico
    const menuItems = computed(() => [
      {
        text: "Prontuário",
        icon: "assignment",
        index: 1,
        disabled: false,
        color: "#1E88E5"
      },
      {
        text: "Solicitação",
        icon: "article",
        index: 2,
        disabled: false,
        color: "#7B68EE"
      },
      {
        text: "Receituário",
        icon: "medication",
        index: 3,
        disabled: false,
        color: "#FFA07A"
      },
      {
        text: "Laudo",
        icon: "content_paste",
        index: 4,
        disabled: false,
        color: "#32CD32"
      },
      {
        text: "Relatório",
        icon: "book",
        index: 5,
        disabled: false,
        color: "#9370DB"
      }
    ])
    
    const resumoProntuarios = ref('')
    const conteudoProntuario = ref('')
    const receitas = ref([])
    const receitaEdit = ref({})
    const indexToEditReceita = ref('')
    const solicitacoesCards = ref([])
    const solicitacoesLaboratorioCards = ref([])
    const examesEdit = ref([])
    const relatorios = ref([])
    const listaPv2 = ref([])
    const dadosProntuario = ref([])
    const valoresExamesOs = ref([])
    const examesSelecionados = ref([])
    const filtroExamesOs = ref('')
    
    const tempoStatusClass = computed(() => {
      if (!props.tempoAtd) return ''
      const parts = props.tempoAtd.split(':').map(part => parseInt(part, 10))
      if (parts.length < 2 || parts.some(isNaN)) return ''
      const [horas = 0, minutos = 0, segundos = 0] = parts
      const totalMinutos = horas * 60 + minutos + (segundos || 0) / 60
      if (totalMinutos >= 30) return 'tempo-alert-high'
      if (totalMinutos >= 15) return 'tempo-alert-medium'
      return ''
    })

    // COMPUTED PROPERTY PARA CONSULTAS COM LAUDOS
    const consultasComLaudos = computed(() => {
      return listaConsultasPaciente.value.map(consulta => ({
        ...consulta,
        laudoCarregado: laudosCarregados.value[consulta.idexamesos] || 'Nenhum laudo cadastrado'
      }))
    })

    const editorProntuarioKey = computed(() => {
      const idAtendimento = props.mFicha?.idAtendimento || 'sem-atendimento'
      const idExamesOS = idExamesOSProntuario.value || 'sem-exame'
      return `${idAtendimento}-${idExamesOS}`
    })

    const idExamesOSProntuario = computed(() => {
      if (props.mFicha?.idExamesos || props.mFicha?.idExamesOS) {
        return props.mFicha.idExamesos || props.mFicha.idExamesOS
      }

      const consultaRelacionada = listaConsultasPaciente.value.find((consulta) =>
        consulta?.idConsulta === props.mFicha?.idConsulta
      )

      return consultaRelacionada?.idexamesos || consultaRelacionada?.idExamesOS || null
    })

    const examesFiltradosOs = computed(() => {
      const filtro = filtroExamesOs.value.trim().toLowerCase()
      if (!filtro) return valoresExamesOs.value
      return valoresExamesOs.value.filter(exame =>
        (exame.exame || '').toLowerCase().includes(filtro)
      )
    })

    const carregarDadosLocaisProntuario = () => {
      conteudoProntuario.value = ''
      solicitacoesCards.value = []
      solicitacoesLaboratorioCards.value = []
      receitas.value = []
      dadosProntuario.value = Array.isArray(store.getters.prontuario) ? store.getters.prontuario : []

      const prontuarioAtual = dadosProntuario.value.find(d => props.mFicha.idAtendimento == d.idAtendimento)
      if (!prontuarioAtual) return

      conteudoProntuario.value = prontuarioAtual.conteudoProntuario || ''
      solicitacoesCards.value = prontuarioAtual.solicitacoes || []
      solicitacoesLaboratorioCards.value = prontuarioAtual.solicitacoesLaboratorio || []
      receitas.value = prontuarioAtual.receitas || []
    }

    const atualizarConteudoProntuario = (conteudo) => {
      conteudoProntuario.value = conteudo || ''
    }
    
    // MÉTODOS PARA SOLICITAÇÃO (PADRÃO)
    const onUpdateSolicitacaoActions = (state) => {
      solicitacaoActionsState.value = state;
    };
    const onUpdateSolicitacaoObservacoes = ({ observacoes, isObs }) => {
      if (!isAddSolicitacao.value) return
      if (dadosEdicaoSolicitacao.value) {
        dadosEdicaoSolicitacao.value.observacoes = observacoes || ''
      }
      if (!isEditSolicitacao.value) return
      const targetList = isLab.value ? solicitacoesLaboratorioCards.value : solicitacoesCards.value
      const targetIndex = isLab.value ? indexToEditLab.value : indexToEdit.value
      if (targetIndex === '' || targetIndex === null || targetIndex === undefined) return
      const solicitacao = targetList[targetIndex]
      if (!solicitacao) return
      solicitacao.observacoes = observacoes || ''
      solicitacao.isObs = !!isObs
    };
    const triggerLimparSolicitacao = () => {
      if (solicitacaoExamesRef.value) {
        solicitacaoExamesRef.value.limparSelecao();
      }
    };
    const triggerCancelarSolicitacao = () => {
      if (solicitacaoExamesRef.value) {
        solicitacaoExamesRef.value.cancelar();
      }
    };
    const triggerSalvarSolicitacao = () => {
      if (solicitacaoExamesRef.value) {
        solicitacaoExamesRef.value.salvarSolicitacao();
      }
    };
    const triggerAbrirPacotesSolicitacao = () => {
      if (solicitacaoExamesRef.value) {
        solicitacaoExamesRef.value.abrirDialogPacotes();
      }
    };
    const triggerCadastrarPacoteSolicitacao = () => {
      if (solicitacaoExamesRef.value) {
        solicitacaoExamesRef.value.abrirCadastroPacote();
      }
    };

    const triggerSalvarSolicitacaoMais = () => {
      continuarAdicionando.value = true
      triggerSalvarSolicitacao()
    }

    const triggerSalvarReceitaMais = () => {
      continuarAdicionando.value = true
      triggerSalvarReceita()
    }

    const triggerSalvarRelatorioMais = () => {
      continuarAdicionando.value = true
      triggerSalvarRelatorio()
    }

    // MÉTODOS PARA RECEITUÁRIO (NOVO PADRÃO)
    const triggerSalvarReceita = () => {
      if(editorReceitaRef.value) {
        editorReceitaRef.value.salvarReceita();
      }
    }
    const triggerCancelarReceita = () => {
        if(editorReceitaRef.value) {
            editorReceitaRef.value.cancelar();
        }
    }

    const triggerSalvarProntuario = () => {
      if (editorProntuarioRef.value) {
        editorProntuarioRef.value.salvarProntuario();
      }
    };
    const triggerCancelarProntuario = () => {
      selectedItem.value = 0; // Go back to Resumo
    };

    const triggerSalvarLaudo = () => {
      if (editorLaudoRef.value) {
        editorLaudoRef.value.salvar();
      }
    };
    const triggerCancelarLaudo = () => {
      fecharEditor();
    };

    const triggerSalvarRelatorio = () => {
      if (editorRelatorioRef.value) {
        editorRelatorioRef.value.salvar();
      }
    };
    const triggerCancelarRelatorio = () => {
      if (editorRelatorioRef.value) {
        editorRelatorioRef.value.voltar();
      }
    };

     const handleReceitaSalva = () => {
      if (continuarAdicionando.value) {
        receitaEdit.value = {}
        isEditarReceita.value = false
        isAddReceita.value = false
        nextTick(() => {
          isAddReceita.value = true
          continuarAdicionando.value = false
        })
      } else {
        isAddReceita.value = false
        isEditarReceita.value = false
      }
      listarReceitasMedicas()
    }

    const getReceitaData = (receitaItem) => {
      if (!receitaItem) return ''
      if (Object.prototype.hasOwnProperty.call(receitaItem, 'dataSelecionada') && receitaItem.dataSelecionada == null) {
        return ''
      }
      return (
        receitaItem.dataSelecionada ||
        receitaItem.dataPrescricao ||
        receitaItem.dataReceita ||
        receitaItem.dataCadastro ||
        receitaItem.data ||
        ''
      )
    }

    const getSolicitacaoData = (solicitacao) => {
      if (!solicitacao) return ''
      if (solicitacao.dataHabilitada === false) {
        return ''
      }
      if (Object.prototype.hasOwnProperty.call(solicitacao, 'dataISO') && solicitacao.dataISO == null) {
        return ''
      }
      return (
        solicitacao.dataISO ||
        solicitacao.dataSelecionada ||
        solicitacao.dataCadastro ||
        solicitacao.data ||
        ''
      )
    }

    const getRelatorioData = (relatorioItem) => {
      if (!relatorioItem) return ''
      return (
        relatorioItem.dataCadastro ||
        relatorioItem.data ||
        ''
      )
    }

    const formatarDataExibir = (value) => {
      const today = () => {
        const now = new Date()
        const d = String(now.getDate()).padStart(2, '0')
        const m = String(now.getMonth() + 1).padStart(2, '0')
        const y = String(now.getFullYear())
        return `${d}/${m}/${y}`
      }
      if (!value) return today()
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        const d = String(value.getDate()).padStart(2, '0')
        const m = String(value.getMonth() + 1).padStart(2, '0')
        const y = String(value.getFullYear())
        return `${d}/${m}/${y}`
      }
      if (typeof value === 'string') {
        const cleanValue = value.split('T')[0].split(' ')[0]
        if (cleanValue.includes('/')) {
          const [d, m, y] = cleanValue.split('/')
          if (d && m && y) return `${d}/${m}/${y}`
        }
        if (cleanValue.includes('-')) {
          const [y, m, d] = cleanValue.split('-')
          if (y && m && d) return `${d}/${m}/${y}`
        }
      }
      return value || today()
    }

    const receitasImpressao = computed(() => {
      return (receitas.value || [])
        .filter((mReceita) => mReceita && mReceita.idReceitaMedica)
        .map((mReceita) => ({
          idReceitaMedica: mReceita.idReceitaMedica,
          idapicfm_especializacao: mReceita.idapicfm_especializacao ?? selectedRQE.value ?? 0,
          dataHabilitada: mReceita.dataHabilitada !== false,
          data_exibir: mReceita.dataHabilitada === false
            ? ''
            : formatarDataExibir(getReceitaData(mReceita) || mReceita.data_exibir)
        }))
    })

    const relatoriosImpressao = computed(() => {
      return (relatorios.value || [])
        .filter((mRelatorio) => mRelatorio && (mRelatorio.id || mRelatorio.idRelatorio))
        .map((mRelatorio) => ({
          idRelatorio: mRelatorio.id || mRelatorio.idRelatorio,
          idapicfm_especializacao: mRelatorio.idapicfm_especializacao ?? selectedRQE.value ?? 0,
          data_exibir: formatarDataExibir(getRelatorioData(mRelatorio) || mRelatorio.data_exibir)
        }))
    })

    const solicitacoesImpressao = computed(() => {
      const solicitacoes = [
        ...(solicitacoesCards.value || []),
        ...(solicitacoesLaboratorioCards.value || [])
      ]
      return solicitacoes
        .filter((solicitacao) => solicitacao && solicitacao.idSolicitacao)
        .map((solicitacao) => ({
          idSolicitacao: solicitacao.idSolicitacao,
          idapicfm_especializacao: solicitacao.idapicfm_especializacao ?? selectedRQE.value ?? 0,
          dataHabilitada: solicitacao.dataHabilitada !== false,
          data_exibir: solicitacao.dataHabilitada === false
            ? ''
            : formatarDataExibir(getSolicitacaoData(solicitacao) || solicitacao.data_exibir)
        }))
    })


    // MÉTODO PARA BUSCAR E ARMAZENAR LAUDOS
    const buscarEArmazenarLaudos = async () => {
      if (!listaConsultasPaciente.value.length) return
      
      carregandoLaudo.value = true
      
      for (const consulta of listaConsultasPaciente.value) {
        const idExamesOS = consulta.idexamesos || consulta.idExamesOS
        if (idExamesOS) {
          try {
            const response = await medicoService.medico.buscarLaudoClinicoPorIdExamesOS(idExamesOS)
            if (response.status === 200 && response.data) {
              laudosCarregados.value[idExamesOS] = response.data.descricaoLaudo || ''
            } else {
              laudosCarregados.value[idExamesOS] = 'Nenhum laudo cadastrado'
            }
          } catch (error) {
            console.error('Erro ao buscar laudo:', error)
            laudosCarregados.value[idExamesOS] = 'Nenhum laudo cadastrado'
          }
        }
      }
      
      carregandoLaudo.value = false
    }

    // MÉTODO PARA SER CHAMADO QUANDO UM LAUDO FOR SALVO/ATUALIZADO
    const onLaudoSalvo = async () => {
      await retornarConsultasPaciente()
      await buscarEArmazenarLaudos()
    }

    // MÉTODOS CORRIGIDOS PARA SOLICITAÇÃO
    const prepararDadosEdicao = (solicitacao, isLaboratorio) => {
      const dataRaw =
        solicitacao.dataISO ||
        solicitacao.dataSelecionada ||
        solicitacao.dataCadastro ||
        solicitacao.data ||
        '';
      const dataISO = typeof dataRaw === 'string' && dataRaw.includes('-') ? dataRaw : '';
      const data = dataISO ? '' : dataRaw;
      const dataHabilitada = Object.prototype.hasOwnProperty.call(solicitacao, 'dataHabilitada')
        ? solicitacao.dataHabilitada
        : !!dataRaw;

      return {
        tipo: isLaboratorio ? 'LABORATORIO' : 'CLINICA',
        items: solicitacao.items || [],
        observacoes: solicitacao.observacoes || '',
        data,
        dataISO,
        dataHabilitada
      }
    }

    const editSolicitacao = (index, isLaboratorio) => {
      let solicitacao
      if (isLaboratorio) {
        solicitacao = solicitacoesLaboratorioCards.value[index]
        indexToEditLab.value = index
      } else {
        solicitacao = solicitacoesCards.value[index]
        indexToEdit.value = index
      }
      
      // Prepara os dados para edição
      dadosEdicaoSolicitacao.value = prepararDadosEdicao(solicitacao, isLaboratorio)
      isLab.value = isLaboratorio
      isEditSolicitacao.value = true
      isAddSolicitacao.value = true
    }

    const aplicarObservacaoSolicitacao = (payload) => {
      if (!payload) return
      const observacoes = payload.observacoes || ''
      const isObs = !!observacoes
      const atualizar = (solicitacao) => {
        solicitacao.observacoes = observacoes
        solicitacao.isObs = isObs
        if (Object.prototype.hasOwnProperty.call(payload, 'dataHabilitada')) {
          solicitacao.dataHabilitada = payload.dataHabilitada
          if (!payload.dataHabilitada) {
            solicitacao.dataISO = null
            solicitacao.data = null
          }
        }
      }
      const solicitacoes = [...solicitacoesCards.value, ...solicitacoesLaboratorioCards.value]
      if (payload.idSolicitacao) {
        const encontrada = solicitacoes.find(s => s.idSolicitacao === payload.idSolicitacao)
        if (encontrada) atualizar(encontrada)
        return
      }
      const payloadIds = (payload.items || [])
        .map(item => item.idExame)
        .filter(Boolean)
        .sort()
        .join(',')
      const payloadData = payload.dataISO || payload.data || ''
      if (!payloadIds) return
      const encontrada = solicitacoes.find(s => {
        const ids = (s.items || [])
          .flatMap(item => item.exames || [])
          .map(exame => exame.idExame)
          .filter(Boolean)
          .sort()
          .join(',')
        if (ids !== payloadIds) return false
        if (!payloadData) return true
        return (s.dataISO || s.data || '') === payloadData
      })
      if (encontrada) atualizar(encontrada)
    }

    const handleSalvarSolicitacao = async (payload) => {
      await listarSolicitacoesExames()
      aplicarObservacaoSolicitacao(payload)
      if (continuarAdicionando.value) {
        triggerLimparSolicitacao()
        continuarAdicionando.value = false
      } else {
        resetarFormularioEdicao()
      }
    }

    const resetarFormularioEdicao = () => {
      isAddSolicitacao.value = false
      isEditSolicitacao.value = false
      isLab.value = false
      indexToEdit.value = ''
      indexToEditLab.value = ''
      dadosEdicaoSolicitacao.value = null
      examesEdit.value = []
    }

    const adcionarSolicitacao = (data) => {
      solicitacoesCards.value.push(data)
    }

    const adicionarSolicitacaoLaboratorio = (data) => {
      solicitacoesLaboratorioCards.value.push(data)
    }

    // MÉTODOS EXISTENTES (mantidos)
    const cancelarReceita = () => {
      isAddReceita.value = false
    }

    const fecharEditor = async () => {
      isAddLaudo.value = false
      consultaAux.value = null
      await retornarConsultasPaciente()
      await buscarEArmazenarLaudos()
    }

    const abrirEncerramento = () => {
      dialogEncerramento.value = true
    }

    const onAtendimentoEncerrado = (resultado) => {
      if (resultado.sucesso) {
        console.log('Atendimento encerrado com sucesso:', resultado.dados)
        EventBus.emit('encerrarAtd', true)
        dialogEncerramento.value = false
      } else {
        console.error('Erro ao encerrar atendimento:', resultado)
        mensagemAlerta.value = resultado.erro || 'Erro ao encerrar atendimento'
        dialogAlerta.value = true
      }
    }

    const onFecharEncerramento = () => {
      dialogEncerramento.value = false
    }

    const editarReceita = (index) => {
      receitaEdit.value = JSON.parse(JSON.stringify(receitas.value[index]))
      indexToEditReceita.value = index
      isEditarReceita.value = true
      isAddReceita.value = true
    }
    
    const excluirReceitaMedica = (receita) => {
      medicoService.medico.deleteReceitaById(receita.idReceitaMedica).then((r) => {
        if (r.status == 200) {
          listarReceitasMedicas()
        }
      })
    }
    
    const listarReceitasMedicas = () => {
      loadReceita.value = true
      medicoService.medico.listarReceitaMedica(props.mFicha.idAtendimento, user.value.id)
        .then((r) => {
          if (r.status == 200) {
            const data = Array.isArray(r.data) ? r.data : []
            receitas.value = data.map(item => ({
              ...item,
              dataHabilitada: Object.prototype.hasOwnProperty.call(item, 'dataHabilitada')
                ? item.dataHabilitada
                : (Object.prototype.hasOwnProperty.call(item, 'dataSelecionada') ? item.dataSelecionada != null : true)
            }))
          }
        })
        .finally(() => {
          loadReceita.value = false
        })
    }
    
    const iniciarExclusao = (relatorio) => {
      relatorio.confirmandoExclusao = true
    }
    
    const cancelarExclusao = (relatorio) => {
      relatorio.confirmandoExclusao = false
    }
    
    const confirmarExclusao = async (relatorio) => {
      try {
        await medicoService.medico.removerRelatorio(relatorio.id)
          .then(({ status }) => {
            if (status == 200) {
              buscarRelatoriosAtendimento()
            }
          })
          .finally(() => {
            relatorio.confirmandoExclusao = false
          })
      } catch (error) {
        console.error('Erro ao excluir relatório:', error)
      }
    }
    
    const buscarRelatoriosAtendimento = () => {
      console.log('Buscando relatórios para atendimento:', props.mFicha.idAtendimento);
      
      loadRelatorio.value = true
      medicoService.medico.buscarRelatoriosAtendimento(props.mFicha.idAtendimento)
        .then(({ status, data }) => {
          if (status == 200) {
            relatorios.value = data
          }
        })
        .finally(() => {
          loadRelatorio.value = false
        })
    }

    // Métodos para carregar consultas e laudos
    const retornarConsultasPaciente = async () => {
      if (blockMethod.value) return
      
      blockMethod.value = true
      
      try {
        const response = await medicoService.medico.retornarConsultasPaciente(
          props.mFicha.idAtendimento, 
          props.mFicha.idServico
        )
        
        listaConsultasPaciente.value = response.data
        
        // Processar cada consulta
        listaConsultasPaciente.value.forEach(consulta => {
          consulta.files = []
          
          if (consulta.status === 0) {
            if (!vertificarExameMedico(consulta)) {
              consulta.colorText = "grey--text text--lighten-1"
              consulta.cor = "grey lighten-1"
              consulta.status = false
              consulta.showCheck = false
            } else {
              consulta.cor = ""
              consulta.status = false
              consulta.showCheck = true
            }
          } else if (consulta.status === 1) {
            if (!vertificarExameMedico(consulta)) {
              consulta.colorText = "grey--text text--lighten-1"
              consulta.cor = "grey lighten-1"
              consulta.status = false
              consulta.showCheck = false
            } else {
              consulta.contador = ""
              consulta.status = false
              consulta.showCheck = true
            }
          } else if (consulta.status === 2) {
            if (!vertificarExameMedico(consulta)) {
              consulta.colorText = "grey--text text--lighten-1"
              consulta.cor = "grey lighten-1"
              consulta.status = false
              consulta.showCheck = false
            } else {
              consulta.colorText = "teal--text text--lighten-4"
              consulta.cor = "teal lighten-2"
              consulta.status = false
              consulta.showCheck = false
            }
          }
        })
        
        console.log('Consultas carregadas:', listaConsultasPaciente.value)
        
        // Buscar laudos para as consultas que exigem laudo
        if (selectedItem.value === 4) {
          buscarEArmazenarLaudos()
        }
        
      } catch (error) {
        console.error("Erro ao retornar consultas:", error)
      } finally {
        blockMethod.value = false
      }
    }

    const vertificarExameMedico = (consulta) => {
      return consulta.idMedico === user.value.id
    }

    // Métodos auxiliares para a seção de Laudos
    const deveMostrarLaudo = (consulta) => {
      return (consulta.exigeLaudoClinico && consulta.cor !== 'grey lighten-1') && 
             consulta.idMedico == user.value.id
    }

    const getCorChipLaudo = (consulta) => {
      const laudo = laudosCarregados.value[consulta.idexamesos] || ''
      return laudo === 'Nenhum laudo cadastrado' || laudo === '' ? items.value[mItem.value].color : 'orange'
    }

    const getIconLaudo = (consulta) => {
      const laudo = laudosCarregados.value[consulta.idexamesos] || ''
      return laudo === 'Nenhum laudo cadastrado' || laudo === '' ? 'add' : 'edit'
    }

    const getTextoLaudo = (consulta) => {
      const laudo = laudosCarregados.value[consulta.idexamesos] || ''
      return laudo === 'Nenhum laudo cadastrado' || laudo === '' ? 'Adicionar' : 'Editar'
    }

    const temLaudoCadastrado = (consulta) => {
      const laudo = (laudosCarregados.value[consulta.idexamesos] || '').toString().trim()
      return laudo !== '' && laudo !== 'Nenhum laudo cadastrado'
    }

    const getCorStatusLaudo = (statusLaudo) => {
      switch (statusLaudo) {
        case 'A': return 'orange'
        case 'L': return 'green'
        default: return 'grey'
      }
    }

    const addListaDeEspera = async () => {
      const idAtendimento = props.mFicha?.idAtendimento || props.mFicha?.id
      if (!idAtendimento) {
        mensagemAlerta.value = 'Não foi possível identificar o atendimento para colocar em espera.'
        dialogAlerta.value = true
        return
      }

      try {
        loadingEspera.value = true
        const response = await medicoService.medico.atendimentoEmEspera(
          idAtendimento
        );

        if (response.status === 200) {
          menu.value = false
          EventBus.emit('addListaDeEspera', true)
          emit('addListaDeEspera', true)
        } else {
          throw new Error('Falha ao adicionar à fila de espera');
        }
        
      } catch (error) {
        console.error('Erro ao adicionar à fila de espera:', error);
        mensagemAlerta.value = 'Erro ao adicionar à fila de espera. Tente novamente.'
        dialogAlerta.value = true
      } finally {
        loadingEspera.value = false
      }
    }

    const getTextoStatusLaudo = (statusLaudo) => {
      switch (statusLaudo) {
        case 'A': return 'ABERTO'
        case 'L': return 'LIBERADO'
        default: return 'PENDENTE'
      }
    }

    const abrirEditorLaudo = (consulta) => {
      consultaAux.value = consulta
      isAddLaudo.value = true
    }

    const carregarValoresExamesOs = async () => {
      const idOs = props.mFicha?.idOrdemServico
      const idMedico = user.value?.id
      if (!idOs || !idMedico) {
        valoresExamesOs.value = []
        return
      }

      loadValoresExamesOs.value = true
      try {
        const response = await medicoService.medico.retornarValorExamesOs(idOs, idMedico)
        valoresExamesOs.value = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.error('Erro ao carregar valores dos exames:', error)
        valoresExamesOs.value = []
      } finally {
        loadValoresExamesOs.value = false
      }
    }

    const getIdExameValor = (exame) => {
      return exame?.idexame || exame?.idExame || exame?.id || null
    }

    const bloquearCadastroLaudo = () => {
      mensagemAlerta.value = 'Atendimento com status atendido. Não é possível cadastrar novos laudos.'
      dialogAlerta.value = true
    }

    const toggleListaExames = () => {
      if (isAtendimentoAtendido.value) {
        bloquearCadastroLaudo()
        return
      }
      mostrarListaExames.value = !mostrarListaExames.value
      if (mostrarListaExames.value && valoresExamesOs.value.length === 0) {
        carregarValoresExamesOs()
      }
    }

    const handleCloseListaExames = () => {
      mostrarListaExames.value = false
      examesSelecionados.value = []
      filtroExamesOs.value = ''
    }

    const handleAddCardClick = () => {
      abrirDialogNovoLaudo()
    }

    const selecionarExameParaLaudo = (exame) => {
      if (isAtendimentoAtendido.value) {
        bloquearCadastroLaudo()
        return
      }
      const idExame = getIdExameValor(exame)
      if (!idExame) return
      const index = examesSelecionados.value.findIndex(item => getIdExameValor(item) === idExame)
      if (index >= 0) {
        examesSelecionados.value.splice(index, 1)
      } else {
        examesSelecionados.value.push(exame)
      }
    }

    const isExameSelecionado = (exame) => {
      const idExame = getIdExameValor(exame)
      if (!idExame) return false
      return examesSelecionados.value.some(item => getIdExameValor(item) === idExame)
    }

    const confirmarExameParaLaudo = () => {
      if (isAtendimentoAtendido.value) {
        bloquearCadastroLaudo()
        return
      }
      if (examesSelecionados.value.length === 0) return
      dialogConfirmarLaudo.value = true
    }

    const executarCadastroLaudo = () => {
      if (isAtendimentoAtendido.value) {
        bloquearCadastroLaudo()
        return
      }
      if (examesSelecionados.value.length === 0) return
      const idos_origem = props.mFicha?.idOrdemServico
      const idmedico_idusuario = user.value?.id
      const idexames = examesSelecionados.value
        .map(exame => getIdExameValor(exame))
        .filter(Boolean)

      if (!idos_origem || !idmedico_idusuario || idexames.length === 0) {
        mensagemAlerta.value = 'Não foi possível montar os dados para cadastrar o laudo.'
        dialogAlerta.value = true
        dialogConfirmarLaudo.value = false
        return
      }

      salvandoExamesLaudo.value = true
      const payload = {
        idos_origem,
        idmedico_idusuario,
        idexames
      }

      medicoService.medico.cadastrarExamesLaudo(payload)
        .then((response) => {
          const status = response?.status
          const data = response?.data
          const ok = (status >= 200 && status < 300) || data?.status === 'success' || data?.success === true
          if (ok) {
            dialogConfirmarLaudo.value = false
            handleCloseListaExames()
            retornarConsultasPaciente()
            buscarEArmazenarLaudos()
            return
          }
          mensagemAlerta.value = 'Não foi possível cadastrar o laudo. Tente novamente.'
          dialogAlerta.value = true
        })
        .catch(error => {
          console.error('Erro ao cadastrar laudo:', error)
          mensagemAlerta.value = 'Erro ao cadastrar laudo. Tente novamente.'
          dialogAlerta.value = true
        })
        .finally(() => {
          salvandoExamesLaudo.value = false
        })
    }

    const temLaudosParaMostrar = () => {
      return listaConsultasPaciente.value.some(consulta => 
        deveMostrarLaudo(consulta)
      )
    }

    const voltarLaudo = async () => {
      isAddLaudo.value = false
      consultaAux.value = null
      await retornarConsultasPaciente()
      await buscarEArmazenarLaudos()
    }

    const voltarRelatorio = () => {
      if (continuarAdicionando.value) {
        if (editorRelatorioRef.value) {
          editorRelatorioRef.value.clear()
        }
        continuarAdicionando.value = false
      } else {
        isAddRelatorio.value = false
        relatorio.value = null
      }
      buscarRelatoriosAtendimento()
    }

    // Watcher para carregar RQE quando habilitado
    watch([habilitarRQE, () => user.value?.id], async ([enabled, userId]) => {
      if (enabled && userId) {
        if (listaRQE.value.length === 0) {
          carregandoLaudo.value = true
          try {
            const response = await medicoService.medico.retornarRQE(userId)
            const data = Array.isArray(response.data) ? response.data : []
            listaRQE.value = data
            if (data.length > 0 && !selectedRQE.value) {
              selectedRQE.value = data[0].id
            }
          } catch (error) {
            console.error('Erro ao buscar RQE:', error)
          } finally {
            carregandoLaudo.value = false
          }
        } else if (listaRQE.value.length > 0 && !selectedRQE.value) {
          selectedRQE.value = listaRQE.value[0].id
        }
      } else if (!enabled) {
        selectedRQE.value = null
      }
    }, { immediate: true })

    const verificarExamesComStatusAberto = () => {
      console.log('Verificar exames com status aberto')
    }

    const confirmarEncerramento = () => {
      desejaEncerrar.value = false
      EventBus.emit('encerrarAtd', true)
    }

    // Métodos auxiliares para solicitações
    const toggleObservacao = (solicitacao) => {
      solicitacao.isObs = !solicitacao.isObs
      if (!solicitacao.isObs) {
        solicitacao.observacoes = ''
      }
    }
    
    const iniciarExclusaoSolicitacao = (solicitacao) => {
      solicitacao.confirmandoExclusao = true
    }
    
    const cancelarExclusaoSolicitacao = (solicitacao) => {
      solicitacao.confirmandoExclusao = false
    }
    
    const confirmarExclusaoSolicitacao = async (index, isLaboratorio) => {
      const targetList = isLaboratorio ? solicitacoesLaboratorioCards.value : solicitacoesCards.value
      const solicitacao = targetList[index]
      if (!solicitacao) return

      try {
        if (solicitacao.idSolicitacao) {
          await medicoService.medico.removerSolicitacaoExame(solicitacao.idSolicitacao)
        }
        targetList.splice(index, 1)
      } catch (error) {
        console.error('Erro ao excluir solicitação:', error)
        mensagemAlerta.value = 'Não foi possível excluir a solicitação no servidor. Tente novamente.'
        dialogAlerta.value = true
      }
    }

    const consultarResumoClinico = async () => {
      loadResumo.value = true
      try {
        const response = await medicoService.medico.consultarResumoClinico(props.mFicha.idPaciente, user.value.id)
        console.log('resumoClinico: ', response);
        
        if (response.status === 200) {
          resumoProntuarios.value = response.data.resumo || ''
        }
      } catch (error) {
        console.error('Erro ao consultar resumo clínico:', error)
      } finally {
        loadResumo.value = false
      }
    }

    // Handlers para eventos do componente pai
    const handleHelp = () => {
      console.log('Help requested')
    }

    const handleLogout = () => {
      console.log('Logout requested')
    }

    const handlePacienteCarregado = (paciente) => {
      console.log('Paciente carregado:', paciente)
    }

    const onListaProntuarios = (lista) => {
      listaProntuariosMeus.value = Array.isArray(lista) ? lista : []
    }

    const abrirDialogNovoLaudo = () => {
      if (isAtendimentoAtendido.value) {
        bloquearCadastroLaudo()
        return
      }
      dialogNovoLaudo.value = true
      if (valoresExamesOs.value.length === 0) {
        carregarValoresExamesOs()
      }
    }

    const fecharDialogNovoLaudo = () => {
      dialogNovoLaudo.value = false
      examesSelecionados.value = []
      filtroExamesOs.value = ''
    }

    const confirmarExameParaLaudoDialog = () => {
      confirmarExameParaLaudo()
      dialogNovoLaudo.value = false
    }

    const toggleSidePanel = () => {
      sidePanelCollapsed.value = !sidePanelCollapsed.value
    }
    
    const prepararVisualizacaoLaudo = async (pdfData) => {
      laudoPdfBlob.value = new Blob([pdfData], { type: 'application/pdf' })

      if (laudoPdfUrl.value) {
        URL.revokeObjectURL(laudoPdfUrl.value)
      }

      laudoPdfUrl.value = URL.createObjectURL(laudoPdfBlob.value)
      laudoPdfSource.value = laudoPdfUrl.value
      dialogLaudoPdf.value = true
    }

    const baixarLaudo = async (idexamesos) => {
      if (!idexamesos) {
        console.error('ID do exame não encontrado para o download.')
        return
      }
      
      currentIdExamesOS.value = idexamesos
      carregandoLaudo.value = true

      const payload = {
        report: "laudoPadraoAPILogo",
        reportType: "pdf",
        idexamesos: idexamesos,
        logo: usarLogo.value
      }

      if (habilitarRQE.value && selectedRQE.value) {
        payload.idapicfm_especializacao = selectedRQE.value
      }

      try {
        const response = await medicoService.medico.downloadReport(payload)
        await prepararVisualizacaoLaudo(response.data)
      } catch (error) {
        console.error('Erro ao baixar o laudo:', error)
        mensagemAlerta.value = 'Erro ao baixar o laudo. Tente novamente.'
        dialogAlerta.value = true
      } finally {
        carregandoLaudo.value = false
      }
    }

    const abrirLaudoNovaGuia = () => {
      const url = laudoPdfUrl.value || laudoPdfSource.value
      if (!url) return
      window.open(url, '_blank', 'noopener,noreferrer')
    }

    const downloadLaudoPdf = () => {
      if (!laudoPdfBlob.value) return
      const url = URL.createObjectURL(laudoPdfBlob.value)
      const a = document.createElement('a')
      a.href = url
      a.download = `laudo_${currentIdExamesOS.value || 'documento'}.pdf`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    }

    const fecharVisualizacaoLaudo = () => {
      dialogLaudoPdf.value = false
      laudoPdfSource.value = null
      laudoPdfBlob.value = null
      if (laudoPdfUrl.value) {
        URL.revokeObjectURL(laudoPdfUrl.value)
        laudoPdfUrl.value = null
      }
    }

    const listarSolicitacoesExames = async () => {
      try {
        const response = await medicoService.medico.retornarSolicitacaoExames(
          props.mFicha.idAtendimento,
          user.value.id
        )
        console.log('response: : ', response.data);
        

        if (response.status === 200 && response.data) {
          const exames = Array.isArray(response.data) ? response.data : []

          const grouped = exames.reduce((acc, exame) => {
            const id = exame.idSolicitacao
            if (!acc[id]) {
              acc[id] = {
                idSolicitacao: id,
                items: [],
                observacoes: exame.observacoes || '',
                isObs: !!exame.observacoes,
                data: exame.data,
                dataISO: exame.data,
                dataHabilitada: Object.prototype.hasOwnProperty.call(exame, 'dataISO')
                  ? exame.dataISO != null
                  : exame.data != null,
                tipo: exame.sadt === 'LABORATORIO' ? 'LABORATORIO' : 'CLINICA'
              }
            }
            acc[id].items.push(exame)
            return acc
          }, {})

          const allSolicitacoes = Object.values(grouped)
          solicitacoesCards.value = allSolicitacoes.filter(s => s.tipo === 'CLINICA')
          solicitacoesLaboratorioCards.value = allSolicitacoes.filter(s => s.tipo === 'LABORATORIO')
        }
      } catch (error) {
        console.error('Erro ao carregar solicitações de exames:', error)
      }
    }

    // Watchers
    watch(() => selectedItem.value, (val) => {
      // Sincroniza mItem com selectedItem
      mItem.value = val

      // Lógica de carregamento baseada na aba selecionada
      if (val === 2) {
        listarSolicitacoesExames()
      } else if (val === 3) {
        listarReceitasMedicas()
      } else if (val === 4) {
        retornarConsultasPaciente()
        carregarValoresExamesOs()
        // Se já houver consultas carregadas, garante a busca/atualização dos laudos
        if (listaConsultasPaciente.value.length > 0) {
          console.log('Selecionou aba Laudo - carregando laudos')
          buscarEArmazenarLaudos()
        }
      } else if (val === 5) {
        buscarRelatoriosAtendimento()
      }
    })

    // Watch para carregar consultas quando o atendimento mudar
    watch(() => props.mFicha.idAtendimento, (newVal) => {
      statusOverride.value = null
      carregarDadosLocaisProntuario()

      if (newVal && selectedItem.value === 4) {
        retornarConsultasPaciente()
      }
    })

    watch(() => props.mFicha.idOrdemServico, (newVal) => {
      if (newVal && selectedItem.value === 4) {
        carregarValoresExamesOs()
      }
    })

    // Watch para atualizar resumo clínico quando o paciente mudar
    watch(() => props.mFicha.idPaciente, (newVal) => {
      if (newVal) {
        consultarResumoClinico()
      }
    })

    // WATCHER PARA CARREGAR LAUDOS QUANDO A LISTA DE CONSULTAS FOR ATUALIZADA
    watch(() => listaConsultasPaciente.value, (newConsultas) => {
      if (newConsultas && newConsultas.length > 0 && selectedItem.value === 4) {
        buscarEArmazenarLaudos()
      }
    }, { immediate: true, deep: true })
    
    const flushProntuarioAntesDeNavegar = async () => {
      if (selectedItem.value !== 1 || !bloqueioSalvamento.value || !editorProntuarioRef.value?.flushPendingSave) {
        return true
      }

      return editorProntuarioRef.value.flushPendingSave()
    }

    const selecionarSecao = async (index) => {
      if (navegacaoBloqueada.value) return
      if (index !== selectedItem.value) {
        const podeNavegar = await flushProntuarioAntesDeNavegar()
        if (!podeNavegar) return
      }
      selectedItem.value = index
    }

    const handleSalvamentoPendente = (status) => {
      bloqueioSalvamento.value = status
    }

    const manterStatusChamada = ({ status } = {}) => {
      if (status === undefined || status === null) return
      statusOverride.value = status
    }

    // Lifecycle hooks
    onMounted(() => {
      // Escutar eventos de laudo salvo
      EventBus.on('laudo-salvo', onLaudoSalvo)
      
      // Carregar listaConsultasPaciente no mounted
      retornarConsultasPaciente()
      carregarDadosLocaisProntuario()
      if (props.mFicha.idPaciente) {
        consultarResumoClinico()
      }
    })

    // NÃO ESQUECER DE REMOVER O LISTENER NO UNMOUNTED
    onUnmounted(() => {
      EventBus.off('laudo-salvo', onLaudoSalvo)
      fecharVisualizacaoLaudo()
    })
    
    return {
      // Refs
      mItem,
      selectedItem,
      dialogEncerramento,
      dialogAlerta,
      mensagemAlerta,
      dialog,
      erroProntuarioVazio,
      dialogLaudo,
      dialogProntuario,
      dialogConfirmarLaudo,
      dialogNovoLaudo,
      desejaEncerrar,
      menu,
      loadReceita,
      loadProntuario,
      loadResumo,
      loadRelatorio,
      loadListaProntuario,
      loadValoresExamesOs,
      listaProntuariosMeus,
      mostrarListaExames,
      navegacaoBloqueada,
      sidePanelCollapsed,
      isAddReceita,
      isEditarReceita,
      isAddSolicitacao,
      isEditSolicitacao,
      isAddLaudo,
      isAddRelatorio,
      isLab,
      consultaAux,
      relatorio,
      blockMethod,
      listaConsultasPaciente,
      editorProntuarioKey,
      idExamesOSProntuario,
      loadingEspera,
      loadSave,
      carregandoLaudo,
      salvandoExamesLaudo,
      dialogLaudoPdf,
      laudoPdfSource,
      laudoPdfUrl,
      listaRQE,
      selectedRQE,
      usarLogo,
      habilitarRQE,
      solicitacaoExamesRef,
      editorReceitaRef,
      editorProntuarioRef,
      editorLaudoRef,
      editorRelatorioRef,
      solicitacaoActionsState,
      
      // NOVAS REFS
      laudosCarregados,
      dadosEdicaoSolicitacao,
      indexToEdit,
      indexToEditLab,
      
      // Data
      items,
      menuItems,
      resumoProntuarios,
      conteudoProntuario,
      receitas,
      receitaEdit,
      indexToEditReceita,
      solicitacoesCards,
      solicitacoesLaboratorioCards,
      examesEdit,
      relatorios,
      listaPv2,
      dadosProntuario,
      valoresExamesOs,
      examesSelecionados,
      filtroExamesOs,
      
      // Computed
      user,
      consultasComLaudos,
      examesFiltradosOs,
      tempoStatusClass,
      carregarDadosLocaisProntuario,
      atualizarConteudoProntuario,
      flushProntuarioAntesDeNavegar,
      selecionarSecao,
      handleSalvamentoPendente,
      manterStatusChamada,
      statusAtual,
      isAtendimentoAtendido,
      onListaProntuarios,
      abrirDialogNovoLaudo,
      fecharDialogNovoLaudo,
      confirmarExameParaLaudoDialog,
      
      // Methods
      onUpdateSolicitacaoActions,
      onUpdateSolicitacaoObservacoes,
      triggerLimparSolicitacao,
      triggerSalvarSolicitacaoMais,
      triggerSalvarReceitaMais,
      triggerSalvarRelatorioMais,
      triggerCancelarSolicitacao,
      triggerSalvarSolicitacao,
      triggerAbrirPacotesSolicitacao,
      triggerCadastrarPacoteSolicitacao,
      triggerSalvarReceita,
      triggerCancelarReceita,
      triggerSalvarProntuario,
      triggerCancelarProntuario,
      triggerSalvarLaudo,
      triggerCancelarLaudo,
      triggerSalvarRelatorio,
      triggerCancelarRelatorio,
      handleReceitaSalva,
      getReceitaData,
      getSolicitacaoData,
      getRelatorioData,
      receitasImpressao,
      solicitacoesImpressao,
      relatoriosImpressao,
      abrirLaudoNovaGuia,
      downloadLaudoPdf,
      fecharVisualizacaoLaudo,

      // NOVOS MÉTODOS PARA LAUDOS
      buscarEArmazenarLaudos,
      onLaudoSalvo,
      consultarResumoClinico,
      
      // NOVOS MÉTODOS PARA SOLICITAÇÃO
      prepararDadosEdicao,
      editSolicitacao,
      handleSalvarSolicitacao,
      resetarFormularioEdicao,
      adcionarSolicitacao,
      adicionarSolicitacaoLaboratorio,
      
      // Métodos existentes
      listarSolicitacoesExames,
      excluirReceitaMedica,
      listarReceitasMedicas,
      iniciarExclusao,
      cancelarExclusao,
      confirmarExclusao,
      buscarRelatoriosAtendimento,
      cancelarReceita,
      editarReceita,
      retornarConsultasPaciente,
      vertificarExameMedico,
      deveMostrarLaudo,
      getCorChipLaudo,
      getIconLaudo,
      getTextoLaudo,
      temLaudoCadastrado,
      getCorStatusLaudo,
      getTextoStatusLaudo,
      abrirEditorLaudo,
      carregarValoresExamesOs,
      selecionarExameParaLaudo,
      isExameSelecionado,
      handleAddCardClick,
      handleCloseListaExames,
      executarCadastroLaudo,
      toggleListaExames,
      confirmarExameParaLaudo,
      temLaudosParaMostrar,
      voltarLaudo,
      voltarRelatorio,
      verificarExamesComStatusAberto,
      confirmarEncerramento,
      toggleObservacao,
      iniciarExclusaoSolicitacao,
      cancelarExclusaoSolicitacao,
      confirmarExclusaoSolicitacao,
      handleHelp,
      handleLogout,
      handlePacienteCarregado,
      abrirEncerramento,
      onAtendimentoEncerrado,
      onFecharEncerramento,
      addListaDeEspera,
      fecharEditor,
      baixarLaudo, // Adicionar o novo método ao retorno
      toggleSidePanel
    }
  }
}
</script>


<style scoped>
.nav-disabled {
  pointer-events: none;
  opacity: 0.6;
  filter: grayscale(0.2);
}

.home-prontuario-root {
  padding-bottom: 16px;
}

.menu-card {
  max-height: 35vh;
  overflow-y: auto;
}

.side-panel-col {
  position: relative;
  overflow: visible;
  transition: max-width 0.3s ease, flex-basis 0.3s ease;
}

.side-panel-col--collapsed {
  max-width: 2px !important;
  flex: 0 0 2px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.side-panel-content {
  position: relative;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Card de Resumo Clínico Separado */
.resumo-card {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.resumo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.15);
}

.resumo-btn {
  transition: all 0.3s ease;
}

.resumo-btn:hover {
  background: rgba(var(--v-theme-surface), 0.9) !important;
  transform: scale(1.02);
}

/* Lista Alinhada à Esquerda */
.left-aligned-list {
  padding: 0;
}

.list-item-left {
  padding-left: 16px;
  padding-right: 16px;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
}

.list-item-left:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
  border-left-color: v-bind('items[selectedItem]?.color');
}

.list-item-left.active-item {
  background-color: rgba(var(--v-theme-on-surface), 0.08);
  border-left-color: v-bind('items[selectedItem]?.color');
}

.list-item-left .v-list-item-title {
  text-align: left;
  font-size: 0.875rem;
}

/* Conteúdo do Resumo Clínico */
.resumo-clinico-content {
  border-radius: 12px;
  overflow: hidden;
}

.resumo-header {
  background: linear-gradient(135deg, rgb(var(--v-theme-primary)), rgb(var(--v-theme-secondary))) !important;
}

.resumo-content {
  background: rgb(var(--v-theme-background));
  min-height: 300px;
  max-height: 60vh;
  flex-grow: 1; /* Permite que o conteúdo ocupe o espaço restante */
  overflow-y: auto;
}

.resumo-html-content {
  line-height: 1.6;
  font-size: 0.9rem;
}

.resumo-html-content ::v-deep(h1),
.resumo-html-content ::v-deep(h2),
.resumo-html-content ::v-deep(h3) {
  color: rgb(var(--v-theme-primary));
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.resumo-display-content ::v-deep(p),
.resumo-display-content ::v-deep(h1),
.resumo-display-content ::v-deep(h2),
.resumo-display-content ::v-deep(h3),
.resumo-display-content ::v-deep(span),
.resumo-display-content ::v-deep(div),
.resumo-display-content ::v-deep(li) {
  color: #000000 !important; /* Força a cor do texto para preto */
}

/* Para o caso de v-html gerar diretamente conteúdo sem tags mais específicas */
.resumo-display-content {
  background-color: white !important;
  flex-grow: 1; /* Ocupa o espaço restante */
  overflow-y: auto; /* Adiciona scroll se o conteúdo for maior que o espaço */
}

.resumo-html-content ::v-deep(p) {
  margin-bottom: 0.8rem;
}

.resumo-html-content ::v-deep(ul),
.resumo-html-content ::v-deep(ol) {
  margin-left: 1.5rem;
  margin-bottom: 0.8rem;
}

.resumo-html-content ::v-deep(li) {
  margin-bottom: 0.3rem;
}

/* Botões de Ação */
.action-btn {
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.15);
}

.alert-soft {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-theme-error), 0.35);
  background: rgba(var(--v-theme-error), 0.08);
  color: rgb(var(--v-theme-error));
}

.solicitacao-observacao :deep(textarea) {
  line-height: 1.3;
  min-height: 52px;
}

.icon-finalizar {
  color: rgb(var(--v-theme-success));
}

.icon-espera {
  color: rgb(var(--v-theme-warning));
}

/* Lista de Procedimentos */
.procedimentos-list {
  max-height: 200px;
  overflow-y: auto;
}

.procedimentos-list .v-list-item {
  min-height: 40px;
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.procedimentos-list .v-list-item:last-child {
  border-bottom: none;
}

/* Estilos gerais */
.h-100 {
  height: 100%;
}

.tempo-display {
  transition: color 0.3s ease;
}

.tempo-alert-medium {
  color: rgb(var(--v-theme-warning));
}

.tempo-alert-high {
  color: rgb(var(--v-theme-error));
}

.actions-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 4px;
  padding-right: 4px;
}

.list-card {
  display: flex;
  flex-direction: column;
}

.list-card-content {
  flex: 0 0 80%;
  max-height: 80%;
  min-height: 0;
}

.list-card-actions {
  flex: 0 0 20%;
  min-height: 0;
  padding: 4px 8px;
}

.bottom-actions {
  margin-top: auto;
}

.actions-right {
  justify-content: flex-end;
}

.rqe-actions :deep(.v-input),
.rqe-actions :deep(.v-select),
.rqe-actions :deep(.v-switch),
.rqe-actions :deep(.v-checkbox) {
  margin: 0;
}


@media (max-width: 960px) {
  .actions-footer :deep(.v-spacer) {
    flex-basis: 100%;
    height: 0;
  }
}

.add-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-card:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(var(--v-theme-on-surface), 0.1);
}

.add-card--disabled {
  pointer-events: none;
  opacity: 0.55;
  box-shadow: none;
}

/* Estilos para listas com marcadores */
ol {
  counter-reset: li;
  list-style: none;
  padding: 0;
  margin-bottom: 1em;
}

ol ol {
  margin: 0 0 0 2em;
}

.rounded-list a {
  position: relative;
  display: block;
  padding: .4em .4em .4em 2em;
  margin: .5em 0;
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  text-decoration: none;
  border-radius: .3em;
  transition: all .3s ease-out;
}

.rounded-list a:hover {
  background: rgba(var(--v-theme-on-surface), 0.04);
}

.rounded-list a:hover:before {
  transform: rotate(360deg);
}

.rounded-list a:before {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: rgb(var(--v-theme-info)); /* Mudado de #00BCD4 */
  height: 2em;
  width: 2em;
  line-height: 2em;
  border: .3em solid rgb(var(--v-theme-surface));
  text-align: center;
  font-weight: bold;
  border-radius: 2em;
  transition: all .4s ease-out;
  color: rgb(var(--v-theme-on-info)); /* Mudado de white */
}

.rounded-exame a {
  position: relative;
  display: block;
  padding: .4em .4em .4em 2em;
  margin: .5em 0;
  background: rgb(var(--v-theme-surface)); /* Mudado de #DAF5D5 */
  color: rgb(var(--v-theme-on-surface)); /* Mudado de #050402 */
  text-decoration: none;
  border-radius: .3em;
  transition: all .3s ease-out;
}

.rounded-exame a:hover {
  background: rgb(var(--v-theme-success)); /* Mudado de #32CD32 */
}

.rounded-exame a:hover:before {
  transform: rotate(360deg);
}

.rounded-exame a:before {
  content: "!";
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: rgb(var(--v-theme-success)); /* Mudado de #32CD32 */
  height: 2em;
  width: 2em;
  line-height: 2em;
  border: .3em solid rgb(var(--v-theme-surface));
  text-align: center;
  font-weight: bold;
  border-radius: 2em;
  color: rgb(var(--v-theme-on-success)); /* Mudado de #fff */
  transition: all .4s ease-out;
}

/* Material Icons */
.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}
</style>
